import React from 'react';
import PropTypes from 'prop-types';

class Add extends React.Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    style: PropTypes.object.isRequired,
  };

  render() {
    return (
      <svg
        style={this.props.style}
        viewBox='0 0 50 50'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'>
        <g stroke={this.props.color} style={{strokeWidth: '8px'}}>
          <path d='M5,25 L45,25'></path>
          <path d='M25,5 L25,45'></path>
        </g>
      </svg>
    );
  }
}

export default Add;
